import * as Yup from 'yup';

// Shared by both AssessmentInfoForm containers — create and update — so the
// same name parts are enforced wherever the form is mounted.
export const validationSchema = Yup.object().shape({
  // A cleared number input casts to NaN, whose default message quotes the cast —
  // typeError keeps the copy readable now that an invalid submit is reachable.
  year: Yup.number()
    .typeError('Enter a year for your assessment')
    .required('Enter a year for your assessment')
    .moreThan(2000, 'Enter a year after 2000'),
  season: Yup.string().required('Enter a season for your assessment'),
  descriptor: Yup.string().required('Enter a descriptor for your assessment')
});
